import React from 'react';
import './LegalNotice.css';
const LegalNotice = () => {
    return (
        <div style={{ backgroundColor: "#F5F3F0" }}>

          <div className="legal-notice-container">
            <div className="legal-notice-content">
                <h1>Legal Notice (Impressum)</h1>

                <section>
                    <h2>Waraq Translations</h2>
                    <p>Owner: Hazar El-Kadri (Einzelunternehmer)</p>
                    <p>Chopinstraße 32</p>
                    <p>40593 Düsseldorf</p>
                    <p>Germany</p>
                </section>

                <section>
                    <h2>Contact</h2>
                    <p>Email: <a href="mailto:translate@wa-raq.de">translate@wa-raq.de</a></p>
                    <p>Phone: <a href="tel:+491712120690">+49 151 74578596</a></p>
                </section>

                <section>
                    <h2>Responsible for Website Content</h2>
                    <p>(according to § 55 Abs. 2 RStV / § 18 MStV)</p>
                    <p><strong>Hazar El-Kadri</strong></p>
                    <p>Chopinstraße 32</p>
                    <p>40593 Düsseldorf, Germany</p>
                </section>

                <section>
                    <h2>Business Form</h2>
                    <p>Einzelunternehmer (sole proprietorship)</p>
                    <p>Operating under the business name <strong>Waraq Translations</strong></p>
                </section>

                <section>
                    <h2>VAT ID</h2>
                    <p>Not applicable — no VAT ID assigned.</p>
                </section>

                <section>
                    <h2>Copyright and Intellectual Property</h2>
                    <p>
                        All content, designs, graphics, texts, and logos on this website are 
                        the intellectual property of Waraq Translations, unless otherwise stated. 
                        Reproduction, distribution, or use of any materials from this website 
                        without prior written consent is prohibited.
                    </p>
                    <p className="copyright">© 2026 Waraq Translations. All Rights Reserved.</p>
                </section>

                <section>
                    <h2>Disclaimer</h2>
                    <p>
                        The content of this website has been prepared with the utmost care. 
                        However, Waraq Translations assumes no responsibility for the accuracy, 
                        completeness, or timeliness of the content. Despite careful control of 
                        external links, Waraq Translations is not responsible for the content 
                        of external websites linked here. The operators of linked sites are 
                        solely responsible for their content.
                    </p>
                </section>
            </div>
        </div>

        </div>

    );
};

export default LegalNotice;